'use strict';

import round from 'lodash.round';

export default function roundToTwoDecimals(num: number): number {
    return round(round(num, 3), 2);
}
